var _g, _rect, _rect2, _line, _g2, _rect3, _g3, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 101,
    viewBox: "0 0 89 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3245_2246)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0102539,
    y: 64.6333,
    width: 8.84876,
    height: 21.1387,
    rx: 4.42438,
    fill: "#546BEA"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.99345,
    y: 65.6165,
    width: 6.88237,
    height: 19.1723,
    rx: 3.44119,
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1241,
    y: 65.6165,
    width: 6.88237,
    height: 19.1723,
    rx: 3.44119,
    fill: "#546BEA",
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44.7456,
    y1: 31.2041,
    x2: 44.7456,
    y2: 48.41,
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3245_2246)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.9304,
    y: 40.0527,
    width: 21.6303,
    height: 12.7815,
    rx: 6.39077,
    fill: "#546BEA"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9136,
    y: 41.0359,
    width: 19.6639,
    height: 10.8152,
    rx: 5.40758,
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3245_2246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43481 73.9734C4.43481 59.0408 16.5401 46.9355 31.4727 46.9355H57.5274C72.46 46.9355 84.5653 59.0408 84.5653 73.9734V86.755C84.5653 94.0855 78.6227 100.028 71.2921 100.028H17.708C10.3774 100.028 4.43481 94.0855 4.43481 86.755V73.9734Z",
    fill: "#546BEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41801 73.9734C5.41801 59.5838 17.0831 47.9187 31.4727 47.9187H57.5274C71.917 47.9187 83.5821 59.5838 83.5821 73.9734V86.755C83.5821 93.5425 78.0797 99.0449 71.2921 99.0449H17.708C10.9204 99.0449 5.41801 93.5425 5.41801 86.755V73.9734Z",
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5398,
    cy: 65.6164,
    r: 9.83196,
    fill: "white",
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5397,
    cy: 65.6161,
    r: 4.91598,
    fill: "#0C4777",
    stroke: "#2133BA",
    strokeWidth: 0.983196
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5733,
    cy: 64.6329,
    r: 1.47479,
    fill: "white",
    stroke: "#2133BA",
    strokeWidth: 0.983196
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9685,
    cy: 65.6164,
    r: 9.83196,
    fill: "white",
    stroke: "#2133BA",
    strokeWidth: 1.96639
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9684,
    cy: 65.6161,
    r: 5.16178,
    fill: "#0C4777",
    stroke: "#2133BA",
    strokeWidth: 0.491598
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0023,
    cy: 64.6329,
    r: 1.72059,
    fill: "white",
    stroke: "#2133BA",
    strokeWidth: 0.491598
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9136 82.8223C38.8464 90.442 49.9073 90.442 54.0859 82.8223",
    stroke: "#2133BA",
    strokeWidth: 1.96639,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7997 26.8473L47.3175 5.1701C47.0056 4.63902 46.5603 4.19867 46.0257 3.89271C45.4912 3.58674 44.886 3.42578 44.2701 3.42578C43.6542 3.42578 43.049 3.58674 42.5144 3.89271C41.9799 4.19867 41.5346 4.63902 41.2227 5.1701L28.7405 26.8473C28.4404 27.361 28.2822 27.9452 28.2822 28.5401C28.2822 29.135 28.4404 29.7193 28.7405 30.233C29.0484 30.7673 29.493 31.21 30.0285 31.5158C30.564 31.8215 31.1713 31.9793 31.7879 31.9729H56.7523C57.3684 31.9788 57.9751 31.8208 58.5101 31.515C59.045 31.2093 59.4891 30.7668 59.7968 30.233C60.0974 29.7195 60.256 29.1354 60.2565 28.5405C60.257 27.9456 60.0994 27.3612 59.7997 26.8473ZM43.1282 14.8447C43.1282 14.5418 43.2485 14.2514 43.4627 14.0373C43.6768 13.8231 43.9672 13.7028 44.2701 13.7028C44.5729 13.7028 44.8634 13.8231 45.0775 14.0373C45.2917 14.2514 45.412 14.5418 45.412 14.8447V20.5541C45.412 20.8569 45.2917 21.1474 45.0775 21.3615C44.8634 21.5757 44.5729 21.696 44.2701 21.696C43.9672 21.696 43.6768 21.5757 43.4627 21.3615C43.2485 21.1474 43.1282 20.8569 43.1282 20.5541V14.8447ZM44.2701 27.4054C43.9313 27.4054 43.6002 27.3049 43.3185 27.1167C43.0368 26.9285 42.8173 26.661 42.6877 26.348C42.558 26.035 42.5241 25.6907 42.5902 25.3584C42.6563 25.0261 42.8194 24.7209 43.0589 24.4814C43.2985 24.2419 43.6037 24.0787 43.9359 24.0126C44.2682 23.9466 44.6126 23.9805 44.9256 24.1101C45.2385 24.2398 45.506 24.4593 45.6942 24.741C45.8825 25.0226 45.9829 25.3538 45.9829 25.6926C45.9829 26.1468 45.8025 26.5825 45.4812 26.9037C45.16 27.2249 44.7244 27.4054 44.2701 27.4054Z",
    fill: "#FDA000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3245_2246",
    x: 0.0102539,
    y: 64.6333,
    width: 8.84888,
    height: 21.1387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.93278,
    dy: 1.47479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3245_2246"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3245_2246",
    x: 33.9304,
    y: 40.0527,
    width: 21.6304,
    height: 12.7817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.93278,
    dy: 1.47479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3245_2246"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3245_2246",
    x: 4.43481,
    y: 46.9355,
    width: 80.1304,
    height: 53.0928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.93278,
    dy: 1.47479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3245_2246"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot2);
export default __webpack_public_path__ + "static/media/robot2.54a009782686671c745b553b2613c479.svg";
export { ForwardRef as ReactComponent };